module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    class: _vm.tableClass
  }, [_c('div', {
    staticClass: "clip"
  }), _vm._v(" "), (_vm.Images && _vm.Images.length) ? _c('div', {
    staticClass: "ticket-messahe-images-wrapper"
  }, _vm._l((_vm.Images), function(img, idx) {
    return _c('div', {
      staticClass: "attach-small-preview cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.previewImage(img)
        }
      }
    }, [(img['attach_preview'] || img['attach_file']) ? _c('img', {
      style: (img['style'] ? img['style'] : false),
      attrs: {
        "src": img['src'],
        "title": img['title']
      }
    }) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.noImages && _vm.noImages.length) ? _c('ul', {
    staticClass: "attach-list-no-image"
  }, _vm._l((_vm.noImages), function(file, i) {
    return _c('li', [_c('div', {
      staticClass: "attach-no-image-preview"
    }, [_vm._v(_vm._s(_vm.getExt(file)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")(file['attach_text'] && String(file['attach_text']).length ? file['attach_text'] + ' - ' : '')))]), _vm._v(" "), _c('a', {
      staticClass: "attach-download",
      attrs: {
        "href": _vm.APIServerUrl + file['attach_file']
      }
    }, [_vm._v(_vm._s(file['attach_name']))]), _vm._v(" "), _c('span', [_vm._v(" (" + _vm._s(file['attach_size']) + ")")])])
  }), 0) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-011c227e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ticketattaches.vue
// module id = 701
// module chunks = 0